import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const budget = [
    {
        path: baseUrlTenant,
        name: "budget",
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "budget-pre-actual-report",
                name: "budget-pre-actual-report",
                component: () => import("@/view/pages/budget/PreActualReportNew")
            },
           /* {
                path: "budget-pre-actual-report-new",
                name: "budget-pre-actual-report-new",
                component: () => import("@/view/pages/budget/PreActualReportNew")
            },*/
            {
                path: "budget-pre-comparision-report",
                name: "budget-pre-comparision-report",
                component: () => import("@/view/pages/budget/ComparisionReportV2")
            },
           /* {
                path: "budget-pre-comparision-report-new",
                name: "budget-pre-comparision-report-new",
                component: () => import("@/view/pages/budget/ComparisionReportV2")
            },*/

        ]
    },
]

export default budget
